import React from 'react'
import styles from '../../catalog.module.scss';
import CTA from 'components/CTA';
import { IoChevronBack as Back } from '@react-icons/all-files/io5/IoChevronBack';
import { HomeLayouts } from '../../../../components/layouts/HomeLayout'
import { Box, Button, Chip, Container, Grid, Typography } from '@mui/material';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { getPriceList, getUdm, updateProduct, setExclusiveProduct, getRestaurantsExclusive } from '../../../../api/products';
import { useState, useEffect } from 'react';
import { toast } from 'react-hot-toast';
import { getArrayOfErrors } from 'utils/errors';
import { useDispatch, useSelector } from 'react-redux';
import { gatSubCate } from '../../../../redux/categories/thunks';
import { setErrorToken } from '../../../../redux/authSlice/authSlice';
import PopUp from '../../../../components/PopUp';
import { AddPrice } from '../../../../components/PopUp/components/AddPrice/AddPrice';
import moment from 'moment';
import { formatNumber } from '../../../../utils/numbers';
import { AiOutlineUpload } from '@react-icons/all-files/ai/AiOutlineUpload';
import { getRestaurantFiter } from '../../../../api/restaurants';

// Descripcion, precio base, categoria, UDM,

const columns = [
    {
        name: 'Fecha',
        size: 'small',
    },
    {
        name: 'Tipo',
        size: 'large',
    },
    {
        name: '$',
        size: 'small',
    },
    // {
    // name: 'Precio Unitario',
    // size: 'medium',
    // },
    {
        name: 'Estado',
        size: 'small',
    },

];

export const Product = () => {
  const { subCategories } = useSelector((state) => state.categories);
  const { id } = useParams();
  const [historiPrices, sethistoriPrices] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [file, setFlie] = useState();
  const { user, token, subscription } = useSelector((state) => state.auth);
  const [values, setValues] = useState({
    subcategoryId: '',
    name: '',
    description: '',
    measurementUnit: '',
    code: '',
    active: '',
    isMarketplace: '',
    iva: '',
    image: '',
    integrationCode: '',
  });
  const { state } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [udm, setUdm] = useState(false);
  const [restaurantOption, setRestaurantOption] = useState('all');
  const [allRestaurants, setAllRestaurants] = useState([]);
  const [selectedRestaurants, setSelectedRestaurants] = useState([]);

  useEffect(() => {
    listPrices();
    dispatch(gatSubCate(token, user.supplierId, null));
    //initialV()
    getUDM();
    loadRestaurants();
    loadExclusiveRestaurants();
  }, []);

  const listPrices = async () => {
    const resp = await getPriceList(token, user.supplierId, id);
    sethistoriPrices(resp.historyPrices);
    setValues({
      subcategoryId: resp.subcategoryId,
      name: resp.name,
      description: resp.description || '',
      measurementUnit: resp.measurementUnit,
      code: resp.code,
      active: resp.isActive,
      isMarketplace: resp.isMarketplace,
      iva: resp.iva,
      //image: "https://cado-space.nyc3.digitaloceanspaces.com/suppliers/Products/imagen-1721941933335.jpeg"
      image: resp.image,
      integrationCode: resp.integrationCode ?? '',
    });
  };

  const handleChangeImage = (e) => {
    setFlie(e.target.files[0]);
  };

  const handleOnchege = (e) => {
    setValues((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleOnchegeChec = (e) => {
    setValues({
      ...values,
      active: e.target.checked,
    });
  };
  const handleOnchegeChecMarket = (e) => {
    setValues({
      ...values,
      isMarketplace: e.target.checked,
    });
  };

  const saved = async () => {
    let data = {};
    const f = new FormData();

    if (!values.code) {
      f.append('subcategoryId', `${values.subcategoryId.toString()}`);
      f.append('name', `${values.name}`);
      f.append('description', `${values.description}`);
      f.append('measurementUnit', `${values.measurementUnit}`);
      f.append('isActive', `${values.active}`);
      f.append('iva', `${values.iva}`);
      f.append('isMarketplace', `${values.isMarketplace}`);
      f.append('image', file);
      if (values.integrationCode) f.append('integrationCode', values.integrationCode);

      // data = {

      // subcategoryId: values.subcategoryId.toString(),
      // name: values.name,
      // measurementUnit: values.measurementUnit,
      // isActive: values.active,
      // isMarketplace: values.isMarketplace,
      // iva: values.iva,
      // image: values.image

      // }
    } else {
      f.append('subcategoryId', `${values.subcategoryId.toString()}`);
      f.append('code', `${values.code}`);
      f.append('name', `${values.name}`);
      f.append('description', `${values.description}`);
      f.append('measurementUnit', `${values.measurementUnit}`);
      f.append('isActive', `${values.active}`);
      f.append('iva', `${values.iva}`);
      f.append('isMarketplace', `${values.isMarketplace}`);
      f.append('image', file);
      if (values.integrationCode) f.append('integrationCode', values.integrationCode);
      // data = {

      // subcategoryId: values.subcategoryId.toString(),
      // name: values.name,
      // measurementUnit: values.measurementUnit,
      // isActive: values.active,
      // code: values.code,
      // isMarketplace: values.isMarketplace,
      // iva: values.iva,
      // image: values.image

      // }
    }

    setLoading(true);

    try {
      const update = await updateProduct(
        state.column.productId,
        user.supplierId,
        f,
        token,
      );

      // Guardar disponibilidad de restaurantes
      if (restaurantOption === 'specific' && selectedRestaurants.length > 0) {
        await setExclusiveProduct(id, selectedRestaurants, token);
      } else if (restaurantOption === 'all') {
        await setExclusiveProduct(id, null, token);
      }

      toast.success('Producto actualizado');
      setTimeout(() => {
        navigate('/catalogo');
        setFlie(null);
        setLoading(false);
      }, 1000);
    } catch (error) {
      if (error.response) {
        const errors = getArrayOfErrors(error.response.data);

        if (
          error.response.data === 'Su token ha caducado por favor vuelve a iniciar sesión'
        ) {
          dispatch(setErrorToken(true));
          setLoading(false);
        } else {
          for (let i = 0; i < errors.length; i++) {
            toast.error(errors[i]);
          }
          setLoading(false);
        }
      } else {
        toast.error('Error interno. Inténtelo más tarde');
        setLoading(false);
      }
    }
  };

  const getUDM = async () => {
    try {
      const udm = await getUdm(token);
      setUdm(udm);
    } catch (error) {
      if (error.response) {
        const errors = getArrayOfErrors(error.response.data);

        if (
          error.response.data === 'Su token ha caducado por favor vuelve a iniciar sesión'
        ) {
          dispatch(setErrorToken(true));
        } else {
          for (let i = 0; i < errors.length; i++) {
            toast.error(errors[i]);
          }
        }
      } else {
        toast.error('Error interno. Inténtelo más tarde');
      }
    }
  };

  const loadRestaurants = async () => {
    try {
      const restaurants = await getRestaurantFiter('', token);
      setAllRestaurants(restaurants);
    } catch (error) {
      if (error.response) {
        const errors = getArrayOfErrors(error.response.data);
        if (
          error.response.data === 'Su token ha caducado por favor vuelve a iniciar sesión'
        ) {
          dispatch(setErrorToken(true));
        } else {
          for (let i = 0; i < errors.length; i++) {
            toast.error(errors[i]);
          }
        }
      } else {
        toast.error('Error interno. Inténtelo más tarde');
      }
    }
  };

  const loadExclusiveRestaurants = async () => {
    try {
      const exclusiveData = await getRestaurantsExclusive(token, id);

      // Si exclusiveData es un array directamente con elementos
      if (Array.isArray(exclusiveData) && exclusiveData.length > 0) {
        setRestaurantOption('specific');
        setSelectedRestaurants(exclusiveData.map((r) => r.id));
      }
      // Si exclusiveData tiene una propiedad restaurants que es un array con elementos
      else if (
        exclusiveData &&
        Array.isArray(exclusiveData.restaurants) &&
        exclusiveData.restaurants.length > 0
      ) {
        setRestaurantOption('specific');
        setSelectedRestaurants(exclusiveData.restaurants.map((r) => r.id));
      }
      // Si es null, undefined, o vacío se mantiene el estado 'all'
      else {
        setRestaurantOption('all');
        setSelectedRestaurants([]);
      }
    } catch (error) {
      setRestaurantOption('all');
      setSelectedRestaurants([]);
    }
  };

  const handleRestaurantOptionChange = (e) => {
    setRestaurantOption(e.target.value);
    if (e.target.value === 'all') {
      setSelectedRestaurants([]);
    }
  };

  const handleRestaurantSelection = (restaurantId) => {
    setSelectedRestaurants((prev) => {
      if (prev.includes(restaurantId)) {
        return prev.filter((id) => id !== restaurantId);
      } else {
        return [...prev, restaurantId];
      }
    });
  };

  return (
    <HomeLayouts>
      <div className={styles.content}>
        <PopUp showModal={showModal} setShowModal={setShowModal}>
          <AddPrice
            product_id={state.column.productId}
            token={token}
            supplier={user?.supplierId}
            user={user?.id}
            setShowModal={setShowModal}
            product={state.column.productName}
          />
        </PopUp>
        <div className={styles.header}>
          <Box
            sx={{
              alignItems: 'center',
              display: { sm: 'flex', md: 'flex', xs: 'block' },
            }}
            flexDirection="row"
            alignContent={'center'}
            justifyContent="space-between"
            display="flex"
          >
            <Box display="flex" flexDirection="row" alignItems="center">
              <Back
                cursor={'pointer'}
                className={styles.back}
                onClick={() => navigate(`/catalogo`)}
              />
              <h1 className={styles.title}>Ver producto</h1>
            </Box>
            <Box
              mt={1}
              flexDirection={'row'}
              sx={{ display: { sm: 'flex', md: 'flex', xs: 'block' } }}
            >
              <Box
                ml={2}
                width={220}
                sx={{ display: { xs: 'none', md: 'flex', sm: 'flex' } }}
              >
                <CTA isDisabled={loading} text="Guardar cambios" onClick={saved} />
              </Box>
            </Box>
          </Box>
        </div>
      </div>
      <Container maxWidth="lg">
        <Grid
          mt={5}
          sx={{ padding: { xs: 0.5, md: 2 } }}
          container
          display="flex"
          flexDirection="row"
          alignItems="center"
        >
          <Grid item xs={12} md={2.5} mr={4}>
            <Typography fontSize={16} fontWeight="BOLD">
              Código
            </Typography>
            <Box
              height={50}
              width={'90%'}
              padding={0.5}
              border={1}
              borderRadius={2}
              borderColor="#E9E7E2"
            >
              <input
                onChange={handleOnchege}
                name="code"
                style={{ width: '100%' }}
                type="text"
                value={values.code}
              />
            </Box>
          </Grid>
          <Grid
            md={3}
            item
            xs={12}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Box mt={2} mr={12} display="flex" alignItems="center">
              <input
                onChange={handleOnchegeChec}
                name="active"
                type="checkbox"
                defaultChecked={state?.column.isActive}
              />
              <Typography fontSize={18} mr={2} ml={1.5}>
                En stock
              </Typography>
            </Box>
          </Grid>
          <Grid
            md={3}
            item
            xs={12}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Box mt={2} mr={12} display="flex" alignItems="center">
              <input
                onChange={handleOnchegeChecMarket}
                name="isMarketplace"
                type="checkbox"
                defaultChecked={state?.column.isMarketplace}
              />
              <Typography fontSize={18} mr={2} ml={1.5}>
                Marketplace
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={5} mr={4} mt={4}>
            <Typography fontSize={16} fontWeight="BOLD">
              Producto/Descripción{' '}
            </Typography>
            <Box
              height={50}
              padding={0.5}
              border={1}
              borderRadius={2}
              borderColor="#E9E7E2"
            >
              <input
                onChange={handleOnchege}
                name="name"
                style={{ width: '100%' }}
                type="text"
                value={values.name}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={5} mr={4} mt={4}>
            <Typography fontSize={16} fontWeight="BOLD">
              Descripción Detallada{' '}
            </Typography>
            <Box padding={0.5} border={1} borderRadius={2} borderColor="#E9E7E2">
              <textarea
                onChange={handleOnchege}
                name="description"
                style={{
                  width: '100%',
                  minHeight: '80px',
                  resize: 'vertical',
                  fontFamily: 'inherit',
                  padding: '8px',
                }}
                value={values.description}
              />
            </Box>
          </Grid>
          <Grid md={3} item xs={12} mt={4}>
            <Typography fontSize={16} fontWeight="BOLD">
              UDM{' '}
            </Typography>
            <Box
              height={50}
              border={1}
              borderRadius={2}
              borderColor="#E9E7E2"
              width={150}
            >
              <select
                onChange={handleOnchege}
                name="measurementUnit"
                value={values.measurementUnit}
                className={styles.selectAddProd}
              >
                {udm &&
                  udm.map((udm) => {
                    return (
                      <option key={udm.id} value={udm.name}>
                        {udm.name}{' '}
                      </option>
                    );
                  })}
              </select>
            </Box>
          </Grid>
          <Grid item xs={12} md={5} mr={4} mt={4}>
            <Box height={50}>
              <Typography fontSize={16} fontWeight="BOLD">
                Categoría{' '}
              </Typography>
              <select
                onChange={handleOnchege}
                name="subcategoryId"
                value={values.subcategoryId}
                className={styles.selectAdd}
              >
                {subCategories &&
                  subCategories.map((category, i) => {
                    return (
                      <optgroup
                        key={i}
                        style={{ fontSize: 12, color: '#49A35B' }}
                        label={category.categoryName}
                      >
                        {category.subcategories.map((subCate, j) => {
                          return (
                            <option
                              key={j}
                              style={{ fontSize: 14, color: 'black' }}
                              value={subCate.subcategoryId}
                            >
                              {' '}
                              {subCate.subcategoryName}{' '}
                            </option>
                          );
                        })}
                        {/* <option style={{ fontSize: 14, color: 'black' }} value={category.subcategoryId} > {category.subcategoryName} </option> */}
                      </optgroup>
                    );
                  })}
              </select>
            </Box>
          </Grid>
          <Grid item xs={12} md={1} mr={4} mt={6}>
            <Typography fontSize={16} fontWeight="BOLD">
              IVA{' '}
            </Typography>
            <Box
              height={50}
              padding={0.5}
              border={1}
              borderRadius={2}
              borderColor="#E9E7E2"
            >
              <input
                onChange={handleOnchege}
                name="iva"
                style={{ width: '100%' }}
                type="text"
                value={values.iva}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={8} mr={4} mt={6}>
            <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
              <Box>
                <Typography fontSize={16} fontWeight="BOLD">
                  Imagen{' '}
                </Typography>
                <Button
                  sx={{
                    mt: 1,
                  }}
                  variant="contained"
                  component="label"
                >
                  Cargar imagen
                  <AiOutlineUpload style={{ marginLeft: 10 }} fontSize={22} />
                  <input
                    accept="image/png, image/jpeg"
                    type="file"
                    name="image"
                    hidden
                    onChange={(e) => handleChangeImage(e)}
                  />
                </Button>
                <Typography>{file && `${file.name}`}</Typography>
              </Box>
              <Box ml={12}>
                {values.image === undefined ? null : (
                  <img width={100} src={values.image} alt="" />
                )}
              </Box>
            </Box>
          </Grid>
          {subscription &&
          subscription.plan.abreviacion === 'enterprise' &&
          user.secondaryRole === 'ADMIN' ? (
            <Grid item xs={12} md={5} mr={4} mt={4}>
              <Typography fontSize={16} fontWeight="BOLD">
                Código de Integración{' '}
              </Typography>
              <Box
                height={50}
                padding={0.5}
                border={1}
                borderRadius={2}
                borderColor="#E9E7E2"
              >
                <input
                  maxLength={50}
                  onChange={handleOnchege}
                  name="integrationCode"
                  style={{ width: '100%' }}
                  type="text"
                  value={values.integrationCode}
                />
              </Box>
            </Grid>
          ) : null}

          <Grid item xs={12} md={10} mt={6}>
            <Typography fontSize={18} fontWeight="BOLD" mb={2}>
              Disponibilidad de Restaurantes
            </Typography>
            <Box border={1} borderRadius={2} borderColor="#E9E7E2" padding={3}>
              <Box mb={3}>
                <Box display="flex" alignItems="center" mb={2}>
                  <input
                    type="radio"
                    name="restaurantOption"
                    value="all"
                    checked={restaurantOption === 'all'}
                    onChange={handleRestaurantOptionChange}
                  />
                  <Typography fontSize={16} ml={1.5}>
                    Todos los restaurantes
                  </Typography>
                </Box>
                <Box display="flex" alignItems="center">
                  <input
                    type="radio"
                    name="restaurantOption"
                    value="specific"
                    checked={restaurantOption === 'specific'}
                    onChange={handleRestaurantOptionChange}
                  />
                  <Typography fontSize={16} ml={1.5}>
                    Restaurantes específicos
                  </Typography>
                </Box>
              </Box>

              {restaurantOption === 'specific' && (
                <Box mt={3}>
                  <Typography fontSize={16} fontWeight="BOLD" mb={2}>
                    Seleccionar Restaurantes:
                  </Typography>
                  <Box
                    maxHeight={300}
                    overflow="auto"
                    border={1}
                    borderRadius={2}
                    borderColor="#E9E7E2"
                    padding={2}
                  >
                    {allRestaurants && allRestaurants.length > 0 ? (
                      allRestaurants.map((restaurant) => (
                        <Box
                          key={restaurant.id}
                          display="flex"
                          alignItems="center"
                          mb={1.5}
                          padding={1}
                          sx={{
                            '&:hover': {
                              backgroundColor: '#f5f5f5',
                              borderRadius: 1,
                            },
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={selectedRestaurants.includes(restaurant.id)}
                            onChange={() => handleRestaurantSelection(restaurant.id)}
                          />
                          <Typography fontSize={15} ml={1.5}>
                            {restaurant.name}
                          </Typography>
                        </Box>
                      ))
                    ) : (
                      <Typography fontSize={14} color="text.secondary">
                        No hay restaurantes disponibles
                      </Typography>
                    )}
                  </Box>
                  <Box mt={2}>
                    <Typography fontSize={14} color="text.secondary">
                      Restaurantes seleccionados: {selectedRestaurants.length}
                    </Typography>
                  </Box>
                </Box>
              )}
            </Box>
          </Grid>

          <Grid item xs={12} md={7} mt={6}>
            <Box
              display={'flex'}
              flexDirection={'row'}
              justifyContent={'space-between'}
              alignItems={'center'}
            >
              <Typography fontSize={16} fontWeight="BOLD">
                Historial de precios{' '}
              </Typography>
              <CTA
                size="small"
                isDisabled={loading}
                text="Agregar Precio"
                onClick={() => {
                  setShowModal(true);
                }}
              />
            </Box>
            <Grid
              mt={3}
              borderRadius={3}
              border={0.5}
              borderColor={'#e4e4e4'}
              display="flex"
              flexDirection={'column'}
              container
            >
              <Grid
                sx={{ borderTopLeftRadius: 5, borderTopRightRadius: 5 }}
                bgcolor={'#e9e7e2'}
                padding={2}
                display="flex"
                flexDirection={'row'}
                container
              >
                {columns.map((column, i) => {
                  return (
                    <Grid
                      md={3}
                      xs={3}
                      item
                      // md={i === 0 ? 2 : i === 1 ? 3.2 : i === 2 ? 2.4 : i === 3 ? 2.2 : i === 4 ? 2.2 : null}
                      // xs={i === 0 ? 3 : i === 1 ? 3 : i === 2 ? 3 : i === 3 ? 2 : i === 4 ? 1 : null}
                      key={`${i}_${column}`}
                    >
                      <Typography
                        sx={{ fontSize: { xs: 15, md: 16 } }}
                        textAlign={'center'}
                        fontWeight={'bold'}
                      >
                        {' '}
                        {column.name}{' '}
                      </Typography>
                    </Grid>
                  );
                })}
              </Grid>
              {historiPrices &&
                historiPrices?.map((history, i) => {
                  return (
                    <Grid
                      key={i}
                      alignItems="center"
                      padding={2}
                      sx={{
                        border: { xs: 1, md: 0 },
                        borderColor: { xs: '#e9e7e2', md: null },
                      }}
                      display="flex"
                      flexDirection={'row'}
                      container
                    >
                      <Grid item md={3} xs={3} display="flex" flexDirection="column">
                        <Typography
                          textAlign={'center'}
                          sx={{ fontSize: { xs: 15, md: 16 } }}
                        >
                          {' '}
                          {moment(history.createdAt).format('DD/MM/YYYY')}{' '}
                        </Typography>
                      </Grid>
                      <Grid item md={3} xs={3}>
                        <Typography
                          textAlign={'center'}
                          sx={{ fontSize: { xs: 15, md: 16 } }}
                        >
                          {' '}
                          {history.tipo}{' '}
                        </Typography>
                      </Grid>
                      <Grid item md={3} xs={3}>
                        <Typography
                          textAlign={'center'}
                          sx={{ fontSize: { xs: 15, md: 16 } }}
                        >
                          {' '}
                          ${formatNumber(history.price)}{' '}
                        </Typography>
                      </Grid>
                      <Grid
                        display={'flex'}
                        flexDirection={'row'}
                        justifyContent={'center'}
                        item
                        md={3}
                        xs={3}
                      >
                        <Chip
                          label={history.status ? 'Activo' : 'Inactivo'}
                          sx={{
                            backgroundColor: history.status
                              ? 'rgba(34, 197, 94, 0.16)'
                              : 'rgba(255, 86, 48, 0.16)',
                            color: history.status ? '#2e6e82' : '#B71D18',
                          }}
                        />
                      </Grid>
                    </Grid>
                  );
                })}
            </Grid>
          </Grid>
        </Grid>
        <Box mt={1} sx={{ display: { xs: 'block', md: 'none', sm: 'none' } }}>
          <CTA isDisabled={loading} text="Guardar cambios" onClick={saved} />
        </Box>
      </Container>
    </HomeLayouts>
  );
};
